<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h2 style="padding-left:10px;">My Account Details</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="safeAccountDetails.sortCode == 'NONE' && !spinner">
                    <p style="color:red; margin:0px; padding-left:10px;">{{ paymentdetailsNotsetupMessage }}</p>
                </v-col>
                <v-col class="d-flex flex-column" md="6" cols="12" v-if="!spinner">
                    <v-card>
                        <v-card-title>Payment Frequency</v-card-title>
                        <v-card-text>
                            <v-select v-model="paymentFrequencySelection" :items="paymentFrequencyOptions"></v-select>
                            <div v-if="paymentFrequencySelection === 'twiceMonthly'">
                                You will be paid out on the first and third 'Tuesday' the month.
                            </div>
                            <div v-if="paymentFrequencySelection === 'monthly'">
                                You will be paid out on the first 'Tuesday' of the month.
                            </div>
                            <div v-if="paymentFrequencySelection === 'weekly'">
                                You will be paid out on  'Tuesday' every week.
                            </div>
                            <div v-if="paymentFrequencySelection === 'daily'">
                                <p >You will be paid out every day 'Monday to Friday' excepting bank holidays.</p>
                                <v-spacer></v-spacer>
                                <v-alert class="alerts" dense text outlined
                                    :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                                    icon="mdi-comment-alert">
                                    This may flag as suspicious activity to your bank, therefore weekly is recommended.
                                </v-alert>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="float-right" v-on:click="updatePaymentFrequency"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                                Update
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>

                <v-col class="d-flex flex-column" md="6" cols="12" v-if="!spinner">
                    <v-card>
                        <v-card-title style="padding-top:12px; padding-bottom:6px;">
                            Bank Account Details

                         
                        </v-card-title>
                        <v-card-text style="padding-bottom: 0px;">
                            <span style="display: inline; font-size: medium;">
                                <b style="display: inline-block">Account Name:</b>&nbsp; <p
                                    style="display: inline-block; margin:0px;">
                                    {{ safeAccountDetails.accountName }}</p>
                            </span>
                            <v-spacer></v-spacer>
                            <span style="display: inline; font-size: medium;">
                                <b style="display: inline-block">Account Number:</b>&nbsp; <p
                                    style="display: inline-block; margin:0px;">
                                    {{ safeAccountDetails.accountNumber }}</p>
                            </span>
                            <v-spacer></v-spacer>
                            <span style="display: inline; font-size: medium;">
                                <b style="display: inline-block">Sort Code:</b>&nbsp; <p
                                    style="display: inline-block; margin:0px;">
                                    {{ safeAccountDetails.sortcode }}</p>
                            </span>
                            <v-spacer></v-spacer>
                            <span style="display: inline; font-size: medium;">
                                <b style="display: inline-block">IBAN:</b>&nbsp; <p
                                    style="display: inline-block; margin:0px;">
                                    {{ safeAccountDetails.iban }}</p>
                            </span>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-if="safeAccountDetails.accountNumber == 'None'"
                                v-on:click="goToChangeAccountDetails" class="navColor float-right"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                                Add Bank Details
                            </v-btn>

                                <v-btn
                                v-if="safeAccountDetails.accountNumber != 'None'"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                                @click="goToChangeAccountDetails();"
                                >
                                Change Bank Details
                                </v-btn>



                        </v-card-actions>
                    </v-card>


                </v-col>
                <v-col class="" md="6" cols="12" v-if="!spinner">
                    <v-card>
                        <v-card-title style="padding-top:12px; padding-bottom:6px; margin-bottom:6px;">
                            Personal Information
                        </v-card-title>
                        <v-card-text>
                            <v-row v-if="getAccountDetails.id != null && getAccount != null">
                                <v-col v-show="getAccount.firstname.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>First
                                        Name:</b>
                                </v-col>
                                <v-col v-show="getAccount.firstname.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    {{ getAccount.firstname }}</v-col>

                                <v-col v-show="getAccount.lastname.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Second
                                        Name:</b>
                                </v-col>
                                <v-col v-show="getAccount.lastname.length > 0" class="pt-0 pb-0" cols="6" md="6">{{
                                getAccount.lastname
                                }}</v-col>

                                <v-col v-show="getAccount.aliasName != null" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Alias:</b>
                                </v-col>
                                <v-col v-show="getAccount.aliasName != null" class="pt-0 pb-0" cols="6" md="6">{{
                                getAccount.aliasName
                                }}</v-col>

                                <v-col v-show="getAccount.email.length > 0" class="pt-0 pb-0" cols="6" md="6"><b>Email
                                        Account:</b></v-col>
                                <v-col v-show="getAccount.email.length > 0" class="pt-0 pb-0" cols="6" md="6">{{
                                getAccount.email
                                }}</v-col>
                                <v-col v-show="getAccount.dob > 0" class="pt-0 pb-0" cols="6" md="6"><b>Date of
                                        birth:</b>
                                </v-col>
                                <v-col v-show="getAccount.email.length > 0" class="pt-0 pb-0" cols="6" md="6">{{
                                moment(getAccount.dob).format("DD/MM/YYYY")
                                }}</v-col>

                                <v-col v-show="getAccount.phone.length > 0" class="pt-0 pb-0" cols="6" md="6"><b>Phone
                                        Number:</b></v-col>
                                <v-col v-show="getAccount.phone.length > 0" class="pt-0 pb-0" cols="6" md="6">{{
                                getAccount.phone
                                }}</v-col>

                                <v-col v-show="getAccountDetails.address1.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Address 1:</b>
                                </v-col>
                                <v-col v-show="getAccountDetails.address1.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    {{
                                    getAccountDetails.address1
                                    }}</v-col>

                                <v-col v-show="getAccountDetails.address2.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Address 2:</b>
                                </v-col>
                                <v-col v-show="getAccountDetails.address2.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    {{
                                    getAccountDetails.address2
                                    }}</v-col>

                                <v-col v-show="getAccountDetails.postcode.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>PostCode:</b>
                                </v-col>
                                <v-col v-show="getAccountDetails.postcode.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    {{
                                    getAccountDetails.postcode
                                    }}</v-col>

                                <v-col v-show="getAccountDetails.townCity.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Town/City:</b>
                                </v-col>
                                <v-col v-show="getAccountDetails.townCity.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    {{
                                    getAccountDetails.townCity
                                    }}</v-col>

                                <v-col v-show="getAccountDetails.region.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Region:</b>
                                </v-col>
                                <v-col v-show="getAccountDetails.region.length > 0" class="pt-0 pb-0" cols="6" md="6">{{
                                getAccountDetails.region
                                }}</v-col>

                                <v-col v-show="getAccountDetails.country.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    <b>Country:</b>
                                </v-col>
                                <v-col v-show="getAccountDetails.country.length > 0" class="pt-0 pb-0" cols="6" md="6">
                                    {{
                                    getAccountDetails.country
                                    }}</v-col>

                                <v-col class="pt-0 pb-0" cols="6" md="6"><b>Created:</b></v-col>
                                <v-col class="pt-0 pb-0" cols="6" md="6">{{ moment(getAccount.createdDate).fromNow() }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="float-right"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                                v-on:click="goToChangePersonalDetails">Change Account
                                Details</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col class="d-flex flex-column" md="6" cols="12" v-if="!spinner">
                    <v-card>
                        <v-card-title>Profile Picture</v-card-title>
                        <v-container>
                            <v-img v-if="profilePicture != undefined" v-bind:src="profilePicture"></v-img>
                        </v-container>
                        <v-card-text v-if="profilePicture == undefined">
                            <p>No profile picture selected. Go to change to upload or select an image. Just uploaded?
                                Try refreshing the screen!</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="float-right"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                                v-on:click="changeProfilePicture()"> Change</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>

                <v-col cols="12" v-if="!spinner">

                    <v-card>
                        <v-card-title>Change Password</v-card-title>
                        <v-form ref="form" class="mx-2" lazy-validation>
                            <v-card-text>
                                An email will be sent to your registered email. Follow the links to change your
                                password.
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <div>
                                    <v-btn id="recaptcha-main2" class="g-recaptcha"
                                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                                        :data-sitekey="siteKey" data-callback="onSubmit">Submit</v-btn>
                                </div>
                            </v-card-actions>
                        </v-form>
                    </v-card>

                </v-col>
                <v-col v-if="spinner" align="center">
                    <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                        size="72" indeterminate></v-progress-circular>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" async defer></script>
<script>

import RestResource from '../RestResource.js';
import { mapGetters, mapActions } from 'vuex';
import accessHelper from '@/mixins/accessHelper.js';
const restResourceService = new RestResource();
export default ({
    name: "MyAccountPage",
    components: {

    },
    mixins: [accessHelper],
    props: {
    },
    data: () => ({
        safeAccountDetails: {
            accountNumber: 'None', sortCode: 'None', iban: 'None' 
        },
        spinner: true,
        showBankDetailsModal: false,
        userAddressInfo: null,
        createdDateFormatted: "",
        paymentdetailsNotsetupMessage: "You need to provide valid payment details in order to withdraw funds.",
        chosenColor: localStorage.getItem(process.env.VUE_APP_THEME),
        profilePicture: undefined,
        siteKey: null,
        recaptchaResponse: "",
        gotSiteKey: false,
        paymentFrequencySelection: undefined,
        paymentFrequencyOptions: ["twiceMonthly","monthly","weekly","daily"]
        
    }),

    mounted: function () {
        window.onSubmit = this.onSubmit;
        this.getBankDetails();
        this.fetchAccountDetails();
        this.paymentFrequencySelection = this.getAccount.paymentFrequency;
    },
    computed:
        mapGetters([
            'getAccount',
            'getAccountBalance',
            'getIsLoadingAccountDetails',
            'getAccountDetails',
        ]),
    watch: {
        getAccountDetails: {
            //Handler just watches for deep mutations
            //Stops anything being called untill account api call finishes
            handler() {
                this.getProfilePicture();
            },
            immediate: true,
            deep: true
        },

        spinner(newval){
            if(!newval){
                this.getRCkey();
            }
        }
    },
    methods: {
        ...mapActions([
            'fetchAccountDetails',
            'fetchAccount',
        ]),
        onSubmit: function (recaptchaResponse) {
            console.log("ONSUBMIT" + recaptchaResponse);
            this.recaptchaResponse = recaptchaResponse;
            this.changePassword();
            
        },
        async getBankDetails() {
            this.spinner = true;
            this.safeAccountDetails = await restResourceService.getBankDetails();
            this.spinner = false;
        },
        async getProfilePicture() {
            this.images = await restResourceService.getAccountAlbum();
            this.images.forEach(element => {
                if (element.name == this.getAccountDetails.profilePic)
                    return this.profilePicture = element.url;
            });
        },
        goToChangeAccountDetails: function () {
            this.$router.push({ path: "/changeaccountdetails" });
        },
        formatDate: function () {
            let date = new Date(this.userInfo.createdDate);
            this.createdDateFormatted = date.getDay() + "/" + date.getMonth() + "/" + date.getFullYear() + " (" + date.getHours() + ":" + date.getMinutes() + ")";
        },
        changeProfilePicture: function () {
            this.$router.push({ path: "/changeProfilePicture" });
        },
        snackmain: function (message) {
            this.$emit('snack', message);
        },
        goToChangePersonalDetails: function () {
            this.$router.push({ path: '/changePersonalDetails' });
        },
        async changePassword() {
            await restResourceService.postPasswordReset(this.getAccount.email, this.recaptchaResponse);
            this.$emit('snack', "Reset password email sent");
        },
        async getRCkey() {
            await restResourceService.getRecaptchaSiteKey().then(value => {
                this.siteKey = value;
                window.siteKey = this.siteKey;
                this.gotSiteKey = true;

                grecaptcha.render('recaptcha-main2', {
                    'sitekey': this.siteKey
                });
                
            }).catch(err => {
                console.log(err);
            });
        },
        async updatePaymentFrequency(){
            const newAccount = structuredClone(this.getAccount);
            delete newAccount.name;
            newAccount.paymentFrequency = this.paymentFrequencySelection;
            if(!this.paymentFrequencyOptions.includes(newAccount.paymentFrequency))
                return this.$emit('snack', "Invalid payment frequency");
            if(this.getAccount.paymentFrequency === newAccount.paymentFrequency)
                return this.$emit('snack', this.getAccount.paymentFrequency + " is already the payment Frequency"); 
            
            this.spinner = true;
            const resStatus = await restResourceService.updateAccount(newAccount);
            this.spinner = false;
            if(resStatus != 400)
                this.$emit('snack', "Payment Frequency updated successfully");

            this.fetchAccount();
        },
    }
})

</script>

<style scoped>

</style>